import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_1/sub2_1_2/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_1_2_bg from '../../assets/images/s2_1_2_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_1_2() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_1_2_bg}
        mainTitle="효율적 서빙의 시작"
        productName="CREAMBOT"
        productModel="T8"
        description="컴팩트한 디자인으로 좁은 공간에서도
무리없이 자율주행 서빙이 가능합니다."
theme='light'
      />
      <Content />
      <Footer />
    </>
  );
}
